import { Card, Row, Col, Image } from 'react-bootstrap';
import icQ from './assets/img/ic-q.svg';
import icA from './assets/img/ic-a.svg';

    const CountryFinancialsBanks = ({ formData, isEditPage}) => {

    return (
        <>
            <Card className="mb-4">
                <Card.Body>
                    {/* Title and Edit Button */}
                    <Row className="align-items-center">
                        <Col>
                            <h3><span className="item-number">4. </span>Financials & Banks</h3>
                            <hr />
                        </Col>
                    </Row>
                    <>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Card>
                                    <Card.Body className="p-3">
                                        <div className="icon-text align-items-center">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icQ} alt="What documents are generally required to open a bank account?" />
                                            </span>
                                            <span className="text">
                                                What documents are generally required to open a bank account?
                                            </span>
                                        </div>
                                    </Card.Body>
                                </Card>

                                <Row className="sub-card-row">
                                    <Col className="justify-content-start">
                                        <Card>
                                            <Card.Body>
                                                <div className="icon-text align-items-center">
                                                    <span className="icon" aria-hidden="true">
                                                        <Image src={icA} alt="What documents are generally required to open a bank account?" />
                                                    </span>
                                                    <span className="text">
                                                        {formData?.country?.name && (
                                                            <>
                                                                {' '}
                                                                <a
                                                                    href={`https://www.google.com/search?q=open+bank+account+requirements+${encodeURIComponent(formData.country.name)}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    (Search for {formData.country.name} requirements)
                                                                </a>
                                                            </>
                                                        )}
                                                    </span>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={6}>
                                <Card>
                                    <Card.Body className="p-3">
                                        <div className="icon-text align-items-center">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icQ} alt="What is the exchange rate to your local currency?" />
                                            </span>
                                            <span className="text">
                                                What is the exchange rate to your local currency?
                                            </span>
                                        </div>
                                    </Card.Body>
                                </Card>

                                <Row className="sub-card-row">
                                    <Col className="justify-content-start">
                                        <Card>
                                            <Card.Body>
                                                <div className="icon-text align-items-center">
                                                    <span className="icon" aria-hidden="true">
                                                        <Image src={icA} alt="What is the exchange rate to your local currency?" />
                                                    </span>
                                                    <span className="text">
                                                        {formData?.currency && (
                                                            <>
                                                                {' '}
                                                                <a
                                                                    href={`https://www.google.com/finance/quote/${formData?.currency}-CHF`} // ✅ dynamic currency to CHF
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    View {formData?.currency}-CHF rate on Google Finance
                                                                </a>
                                                            </>
                                                        )}
                                                    </span>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </>
                </Card.Body>
            </Card>
        </>
    );
};

export default CountryFinancialsBanks;
